import { request } from './http.js'

export async function fetchIndustries() {
  const data = await request('/api/industries')
  return data.industries || []
}

export async function fetchIndustryMarket({
  industry,
  start,
  end,
  page = 1,
  pageSize = 20,
  sortBy = 'changePct',
  sortOrder = 'asc',
}) {
  const params = new URLSearchParams({
    start,
    end,
    page: String(page),
    pageSize: String(pageSize),
    sortBy,
    sortOrder,
  })
  if (industry) params.set('industry', industry)
  return request(`/api/industry-market?${params.toString()}`)
}

export async function fetchIndustryTrend({ industries, start, end }) {
  const params = new URLSearchParams({ start, end })
  const list = Array.isArray(industries) ? industries : [industries]
  params.set('industries', list.filter(Boolean).join(','))
  return request(`/api/industry-trend?${params.toString()}`)
}
